import { Component, OnInit } from '@angular/core';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { ApiEmailService } from 'src/app/___LOGIC/__api/api-email.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-budget-builder',
  templateUrl: './budget-builder.component.html',
  styleUrls: ['./budget-builder.component.css']
})
export class BudgetBuilderComponent implements OnInit {

  clientDetails = {};
  plans = [];

  createdCotizaciones = [];

  cotizacion = {
    code: null,
    token: null,
    dueDate: null,
    date: null,
    paid: null,
    discount: null,
    total: null,
    data: null,
    FK_ID_plan: null,
    FK_ID_clientDetails: null,
    FK_ID_clientOrder: null
  };

  token;
  loading =  false;

  constructor(private resolver: ResolverService,private apiConnector: ApiConnectorService,private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private emailApi: ApiEmailService ) {}

  ngOnInit(): void {
    this.clientDetails = {};
  }

  getClientData(){
    if(this.resolver.getDependency('getClientDetails') && this.resolver.getDependency('getClientDetails').records){
      this.clientDetails = this.resolver.getDependency('getClientDetails').records[0];
    }else
    return this.clientDetails;
  }

  getPlans(){
    return this.plans;
  }

  getField(field){
    if(this.clientDetails){
      return this.clientDetails[field];
    }else{
      return null;
    }
  }

  getPhotoUrlOld(){
    return 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/'+ this.getField('imageUrl') +'/public';
  }

  getPhotoUrl(){
    let url;
    if(this.clientDetails['imageUrl']){
      url = 'https://voyjaleas-assets-worker.sebtec12.workers.dev/'+this.clientDetails['imageUrl'];
    }else{
      url = '';
    }
    return url;
  }

  setDate(event){
    this.cotizacion.dueDate = event;
  }

  getCotizacionData(){
    return this.cotizacion;
  }

  processGetPlans(res){
    if(res && res.records){
        /* this.properties = res.props; */
      this.plans = res.records;
    }
  }

  prepareObj(){
    if(this.commonFunctions.getSelectedClientId()){
      this.cotizacion.FK_ID_clientDetails = this.commonFunctions.getSelectedClientId();
      this.cotizacion.data = JSON.stringify(this.plans);
      this.cotizacion.total = 0;
      this.cotizacion.date = this.commonFunctions.getCurrentDate('');
      this.cotizacion.FK_ID_clientOrder = '9999';
      this.cotizacion.paid = 0;
    }else{
      this.guiFlow.openSimpleSnackBar('Select a client', 'warning');
    }
    
    
    return this.cotizacion;
  }

  isFormValid(){
    // TO DO
    if(this.checkMandatoryFields()){
      return true;
    }else{
      //this.guiFlow.reportError('Missing mandatory fields','Ok');
      return false;
    }
  }

  checkMandatoryFields(){
    let valid = true;
    if(!this.cotizacion.FK_ID_clientDetails){
      this.guiFlow.openSimpleSnackBar('Seleccione un cliente', 'warning');
      valid = false;
    }
    if(!this.cotizacion.FK_ID_plan){
      this.guiFlow.openSimpleSnackBar('Seleccione un plan', 'warning');
      valid = false;
    }
    if(!this.cotizacion.dueDate){
      this.guiFlow.openSimpleSnackBar('Seleccione una fecha de vencimiento', 'warning');
      valid = false;
    }
    if(!this.cotizacion.discount){
      this.cotizacion.discount = 0;
    }
    return valid;
  }

  reportMissingPlan(){

  }

  getClientCotizaciones(){
    if(this.resolver.getDependency('cotizacion') && this.resolver.getDependency('cotizacion').records){
      return this.resolver.getDependency('cotizacion').records;
    }else{
      return [];
    }
  }

  sendCotizacion(){
  }

  onSelection(event){
    debugger    
    this.clientDetails = event;
    this.cotizacion.FK_ID_clientDetails = event.id;
    this.commonFunctions.setSelectedClientId(event.id);
    this.resolver.getClientDetails(true);
    /* this.resolver.getPlans(this.commonFunctions.getSelectedClientId(),true); */
    this.createdCotizaciones = this.resolver.genericGet('cotizacion','FK_ID_clientDetails',this.commonFunctions.getSelectedClientId(),true)
  }

  onPlanSelection(event){
    this.cotizacion.FK_ID_plan = event.id;
  }

  reload(){
    /* this.resolver.getPlans(this.commonFunctions.getSelectedClientId(),true); */
  }

  isUserSelected(){
    return this.commonFunctions.getSelectedClientId();
  }

  processBudgetCreation(){

    this.sendBudgetToClient();
  }

  isLoading(){
    return this.loading;
  }

  createCotizacion(){
    if(this.isFormValid()){
      if(this.plans && this.plans.length>0){ 
        this.loading = true; 
        this.cotizacion.token = this.commonFunctions.generateToken();
        this.cotizacion.code = this.commonFunctions.generateRandomNumber6Digit();
        this.apiConnector.newDynamicApiRequest('post', 'cotizacion', this.prepareObj())
        .subscribe(
          (response) => {

            if(response && response.OK){
              console.log('Exito en guardar cotización');
              this.createdCotizaciones? this.createdCotizaciones.push(response.OK.records) : null;
              this.guiFlow.reportSuccess('Cotización creada');
              this.processBudgetCreation();
            }else{
              this.guiFlow.reportError('Error al guardar cotización','Budget builder al createCotizacion()');
            }
            this.loading = false; 
          },
          (error) => {
            this.loading = false; 
            this.guiFlow.reportError(error,'budget builder en createCotizacion');
          }
        )
      }else{
        this.guiFlow.reportError('User does not have plans related','')
      }
    }else{
      /* this.guiFlow.reportError('Faltan campos obligatorios','budget-builder') */
    }
  }

  sendBudgetToClient(){
    let data = {
      token: this.cotizacion.token,
      code: this.cotizacion.code,
      clientDetails: this.clientDetails,
      link: this.resolver.getBugdetLinkAccess(this.cotizacion.token)
    };

    if(this.clientDetails && this.clientDetails['email']){
        this.emailApi.emailSender('sendCotizacion','sendCotizacion',this.clientDetails['email'],data).subscribe( /*  ,*/
        (response) => {
          this.resolver.processAnswer(response,null,null,'📩');
        },
        (error) => {
          this.resolver.processAnswer(error,null,null,null);
        }
      );
    }else{
      this.guiFlow.openSimpleSnackBar('No email address selected to send email','error');
    }

    
  }

}
/* 

2	code	varchar(12)	utf8_unicode_ci		No	None			Change Change	Drop Drop	
More More
	3	token	varchar(24)	utf8_unicode_ci		No	None			Change Change	Drop Drop	
More More
	4	date	date			No	None			Change Change	Drop Drop	
	5	paid	tinyint(4)			No	None			Change Change	Drop Drop	
	6	discount	int(11)			No	None			Change Change	Drop Drop	
	7	total	double			No	None			Change Change	Drop Drop	
	8	dueDate	date			No	None			Change Change	Drop Drop	
	9	data	text	utf8_unicode_ci		No				Change Change	Drop Drop	
	10	FK_ID_clientOrder	int(11)			No	None			Change Change	Drop Drop	
	11	FK_ID_plan	int(11)			No	None			Change Change	Drop Drop	
  FK_ID_clientDetails
	12		int(11)			No	None			Change Change	Drop Drop	
More More
 */